export default [
    {
      reducerKey: 'accounts-marketplace/list',
      sagaKey: 'accountsMarketplaceListSaga',
      importReducer: () => import(/* webpackChunkName: "domain-marketplace" */ 'modules/AccountsMarketplace/Categories/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-marketplace" */ 'modules/AccountsMarketplace/Categories/store/saga'),
    },
    {
      reducerKey: 'accounts-marketplace/category',
      sagaKey: 'accountsMarketplaceCategorySaga',
      importReducer: () => import(/* webpackChunkName: "domain-marketplace" */ 'modules/AccountsMarketplace/Category/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-marketplace" */ 'modules/AccountsMarketplace/Category/store/saga'),
    },
    {
      reducerKey: 'accounts-marketplace/products',
      sagaKey: 'accountsMarketplaceProductsSaga',
      importReducer: () => import(/* webpackChunkName: "domain-marketplace" */ 'modules/AccountsMarketplace/Products/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-marketplace" */ 'modules/AccountsMarketplace/Products/store/saga'),
    },
    {
      reducerKey: 'accounts-marketplace/product',
      sagaKey: 'accountsMarketplaceProductSaga',
      importReducer: () => import(/* webpackChunkName: "domain-marketplace" */ 'modules/AccountsMarketplace/Product/store/reducer'),
      importSaga: () => import(/* webpackChunkName: "domain-marketplace" */ 'modules/AccountsMarketplace/Product/store/saga'),
    },
]
